"use client";

import { type RefObject } from "react";

interface SearchInputFieldProps {
  query: string;
  loading: boolean;
  inputRef?: RefObject<HTMLInputElement | null>;
  autoFocus?: boolean;
  onQueryChange: (value: string) => void;
  onClear: () => void;
}

export function SearchInputField({
  query,
  loading,
  inputRef,
  autoFocus,
  onQueryChange,
  onClear,
}: SearchInputFieldProps) {
  return (
    <div className="relative w-full">
      {/* Search Icon */}
      <div className="absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none">
        <svg
          className="w-3.5 h-3.5 text-[#8f98a0]"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>

      {/* Input */}
      <input
        className="w-full rounded-md border border-[#2a475e] bg-[#1b2838] pl-8 pr-8 py-1.5 text-[13px] text-white placeholder-[#8f98a0] focus:border-[#66c0f4] focus:outline-none focus:ring-2 focus:ring-[#66c0f4]/30 transition-all shadow-sm hover:border-[#3a556e] hover:bg-[#1f2e3f] focus:bg-[#1f2e3f]"
        placeholder="Search games, publishers, IDs..."
        ref={inputRef}
        autoFocus={autoFocus}
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
      />

      {/* Clear Button */}
      {query && !loading && (
        <button
          onClick={onClear}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#8f98a0] hover:text-white transition-colors"
          aria-label="Clear search"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Loading Spinner */}
      {loading && (
        <div className="absolute right-2.5 top-1/2 -translate-y-1/2">
          <svg
            className="animate-spin h-4 w-4 text-[#66c0f4]"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
      )}
    </div>
  );
}
